import { render, staticRenderFns } from "./TermsAndConditionsDialog.vue?vue&type=template&id=77ab0ba9&scoped=true"
import script from "./TermsAndConditionsDialog.vue?vue&type=script&lang=ts"
export * from "./TermsAndConditionsDialog.vue?vue&type=script&lang=ts"
import style0 from "./TermsAndConditionsDialog.vue?vue&type=style&index=0&id=77ab0ba9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ab0ba9",
  null
  
)

export default component.exports